import useLogging from '@/hooks/useLogging';
import { IntrospectUserResponse } from '@oncolens/oncolens-ui/lib/dto/user/User';
import { useIntrospect } from '@oncolens/oncolens-ui/lib/hooks/introspect/useIntrospect';
import useAuthStore from '@oncolens/oncolens-ui/lib/stores/AuthStore';
import React from 'react';
import shallow from 'zustand/shallow';
import Router from './components/Router';
import { Header, Navigation } from './features/home';
import { logout } from './services/LogoutService';
import { FFContextProvider } from '@harnessio/ff-react-client-sdk';
import { FeatureFlagService } from './utils/featureFlagService';

function useCheckAuthorization() {
  const [setDomainUser, hasRole] = useAuthStore((x) => [x.setDomainUser, x.hasRole], shallow);
  useIntrospect({
    onSuccess: (response: IntrospectUserResponse) => {
      setDomainUser(response.domainUser);

      if (!hasRole('Chancellor')) {
        logout();
      }
    },
  });
}

export default function App() {
  useCheckAuthorization();
  useLogging();
  const domainUser = useAuthStore((x) => x.domainUser);

  const featureFlagTarget = domainUser
    ? {
        name: domainUser.email,
        identifier: domainUser.email,
        attributes: {
          userId: domainUser.id,
          email: domainUser.email,
        },
      }
    : { name: 'anonymous', identifier: 'anonymous' };

  return (
    <FFContextProvider target={featureFlagTarget} apiKey={FeatureFlagService.getApiKey()} async>
      <div className="h-full">
        <Header />
        <div className="flex h-full">
          <Navigation />
          <Router />
        </div>
      </div>
    </FFContextProvider>
  );
}
